module.exports = __webpack_public_path__ + "static/media/high-five.fcc14902.svg";